var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('absences-editor-employee-select',{attrs:{"editAbsence":_vm.editAbsence,"step":_vm.step},on:{"goToNextStep":function($event){return _vm.$emit('goToNextStep')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }